module.exports = __webpack_public_path__ + "static/media/x-outline-icon.4597b819.svg";